<template>
  <div class="md-list-tile-subtitle">
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: "BsListTileSubtitle"
}
</script>

<style scoped>

</style>
